var _defs, _rect, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateEmployeeProfileBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1297 525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#edeefc;}.cls-2{fill:#dddef6;}.cls-3{fill:#fff;}.cls-4{fill:#0d37c9;}.cls-5{fill:#2c3a64;}.cls-6{fill:#eea886;}.cls-7{fill:#22d696;}.cls-8{fill:#e9a4b3;}.cls-9{fill:#d998a9;}.cls-10{fill:none;stroke:#c9798d;stroke-miterlimit:10;stroke-width:2px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Surface-2",
    className: "cls-1",
    x: 8.32,
    y: 91.44,
    width: 1280,
    height: 423,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2-2",
    "data-name": "Rectangle 2-2",
    className: "cls-2",
    d: "M867.37,22.42h340.82V359.8H867.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2-2-2",
    "data-name": "Rectangle 2-2-2",
    className: "cls-3",
    d: "M846.37,37.42h340.82V374.8H846.37Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    className: "cls-4",
    x: 940.57,
    y: 301.04,
    width: 156.09,
    height: 7.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    className: "cls-4",
    x: 962.68,
    y: 326.34,
    width: 111.88,
    height: 7.71
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    className: "cls-4",
    x: 1005.49,
    y: 264.37,
    width: 26.24,
    height: 4.86
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125-2",
    "data-name": "Path 125-2",
    className: "cls-2",
    d: "M1074.56,142.45c28.69-57.86,17.09-111.38-10.27-125.82-22.41-11.83-62.85-1.27-72.48,21.1-5.79,13.44-4.26,37.88.68,54.93,8.5,29.38-11.92,35.16-6.5,51.67,6.33,19.32,27.22,37.12,27.22,37.12h0s-5.26,8.86-5.11,9,14-21.25,26.15-40.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_76-2",
    "data-name": "Group 76-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75-2",
    "data-name": "Group 75-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126-2",
    "data-name": "Path 126-2",
    className: "cls-2",
    d: "M1006.39,78.48h-.09c-.92-.22-2.37-4.63-2.66-5.5-.06-.24-.21-.69-.4-1.3-1.14-3.52-3.81-11.77-2.77-14.93.33-1,.84-1.58,1.52-1.72,1.46-.3,3.13,1.55,3.2,1.63l0,0v.06c.38,3.47,2.24,20.82,1.44,21.61A.39.39,0,0,1,1006.39,78.48Zm-4.06-23.16a1.24,1.24,0,0,0-.27,0c-.56.11-1,.62-1.27,1.49-1,3.06,1.73,11.53,2.77,14.72.2.62.34,1.07.41,1.3.67,2.11,1.87,5.15,2.41,5.28l0,0c.51-.69-.66-13.4-1.52-21.29-.23-.24-1.47-1.51-2.58-1.51Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_78-2",
    "data-name": "Group 78-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77-2",
    "data-name": "Group 77-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127-2",
    "data-name": "Path 127-2",
    className: "cls-2",
    d: "M1141.92,215.9h-32c-6.62-12.08-12-21.53-12-21.53s-4.31,7.86-7.65,21.53H982.68a92.83,92.83,0,0,1-1.4-22.51s-5.75,10.39-12.42,22.51H932.7c9.6-18,27.57-50.67,31.66-54.93,5.13-5.38,34.86-25.93,56.09-32.64s33.31-.23,33.31-.23,21.81,3.93,42,11.93C1103.66,143.17,1125.56,183.6,1141.92,215.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_80-2",
    "data-name": "Group 80-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79-2",
    "data-name": "Group 79-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128-2",
    "data-name": "Path 128-2",
    className: "cls-2",
    d: "M1039.58,22s29.66,4.28,25.32,48.06-30.52,40.3-32.26,40.26-26.26.91-28.38-52.51C1004.26,57.77,1003.27,18.27,1039.58,22Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_82-2",
    "data-name": "Group 82-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81-2",
    "data-name": "Group 81-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129-2",
    "data-name": "Path 129-2",
    className: "cls-2",
    d: "M1052.76,102.52s-1.83,22.77,2.55,29.59-3.75,16.08-20.52,12.92S1019,132.35,1019,132.35s4.7-14,3.33-25.3S1052.76,102.52,1052.76,102.52Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84-2",
    "data-name": "Group 84-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83-2",
    "data-name": "Group 83-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130-2",
    "data-name": "Path 130-2",
    className: "cls-2",
    d: "M1063.18,130.1s-20.57,52.09-33.07,61.14c0,0-16.42-53.12-15.27-60.9C1014.84,130.34,1039.6,120.64,1063.18,130.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85-2",
    "data-name": "Group 85-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131-2",
    "data-name": "Path 131-2",
    className: "cls-2",
    d: "M1024.51,108.3a25.9,25.9,0,0,0,24.93-2.85,16.06,16.06,0,0,1-12.47,8.06C1027.92,114.51,1024.51,108.3,1024.51,108.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_132-2",
    "data-name": "Path 132-2",
    className: "cls-2",
    d: "M1033.26,43.1S1053.11,74.67,1074,82c0,0,11.4-53-35.7-64.07s-39.73,53.5-36.21,70.73C1002.08,88.65,1011.89,63.31,1033.26,43.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86-2",
    "data-name": "Group 86-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125-2-2",
    "data-name": "Path 125-2-2",
    className: "cls-5",
    d: "M1056.56,142.45c28.69-57.86,17.09-111.38-10.27-125.82-22.41-11.83-62.85-1.27-72.48,21.1-5.79,13.44-4.26,37.88.68,54.93,8.5,29.38-11.92,35.16-6.5,51.67,6.33,19.32,27.22,37.12,27.22,37.12h0s-5.26,8.86-5.11,9,14-21.25,26.15-40.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_76-2-2",
    "data-name": "Group 76-2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75-2-2",
    "data-name": "Group 75-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126-2-2",
    "data-name": "Path 126-2-2",
    className: "cls-6",
    d: "M988.39,78.48h-.09c-.92-.22-2.37-4.63-2.66-5.5-.06-.24-.21-.69-.4-1.3-1.14-3.52-3.81-11.77-2.77-14.93.33-1,.84-1.58,1.52-1.72,1.46-.3,3.13,1.55,3.2,1.63l0,0v.06c.38,3.47,2.24,20.82,1.44,21.61A.39.39,0,0,1,988.39,78.48Zm-4.06-23.16a1.24,1.24,0,0,0-.27,0c-.56.11-1,.62-1.27,1.49-1,3.06,1.73,11.53,2.77,14.72.2.62.34,1.07.41,1.3.67,2.11,1.87,5.15,2.41,5.28l0,0c.51-.69-.66-13.4-1.52-21.29-.23-.24-1.47-1.51-2.58-1.51Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_78-2-2",
    "data-name": "Group 78-2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77-2-2",
    "data-name": "Group 77-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127-2-2",
    "data-name": "Path 127-2-2",
    className: "cls-7",
    d: "M1123.92,215.9h-32c-6.62-12.08-12-21.53-12-21.53s-4.31,7.86-7.65,21.53H964.68a92.83,92.83,0,0,1-1.4-22.51s-5.75,10.39-12.42,22.51H914.7c9.6-18,27.57-50.67,31.66-54.93,5.13-5.38,34.86-25.93,56.09-32.64s33.31-.23,33.31-.23,21.81,3.93,42,11.93C1085.66,143.17,1107.56,183.6,1123.92,215.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_80-2-2",
    "data-name": "Group 80-2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79-2-2",
    "data-name": "Group 79-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128-2-2",
    "data-name": "Path 128-2-2",
    className: "cls-8",
    d: "M1021.58,22s29.66,4.28,25.32,48.06-30.52,40.3-32.26,40.26-26.26.91-28.38-52.51C986.26,57.77,985.27,18.27,1021.58,22Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_82-2-2",
    "data-name": "Group 82-2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81-2-2",
    "data-name": "Group 81-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129-2-2",
    "data-name": "Path 129-2-2",
    className: "cls-8",
    d: "M1034.76,102.52s-1.83,22.77,2.55,29.59-3.75,16.08-20.52,12.92S1001,132.35,1001,132.35s4.7-14,3.33-25.3S1034.76,102.52,1034.76,102.52Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84-2-2",
    "data-name": "Group 84-2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83-2-2",
    "data-name": "Group 83-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130-2-2",
    "data-name": "Path 130-2-2",
    className: "cls-8",
    d: "M1045.18,130.1s-20.57,52.09-33.07,61.14c0,0-16.42-53.12-15.27-60.9C996.84,130.34,1021.6,120.64,1045.18,130.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85-2-2",
    "data-name": "Group 85-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131-2-2",
    "data-name": "Path 131-2-2",
    className: "cls-9",
    d: "M1006.51,108.3a25.9,25.9,0,0,0,24.93-2.85,16.06,16.06,0,0,1-12.47,8.06C1009.92,114.51,1006.51,108.3,1006.51,108.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_132-2-2",
    "data-name": "Path 132-2-2",
    className: "cls-5",
    d: "M1015.26,43.1S1035.11,74.67,1056,82c0,0,11.4-53-35.7-64.07s-39.73,53.5-36.21,70.73C984.08,88.65,993.89,63.31,1015.26,43.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_213-3",
    "data-name": "Path 213-3",
    className: "cls-10",
    d: "M1009.79,93.94a24.35,24.35,0,0,0,5.13,1.71,8.13,8.13,0,0,0,5.27-.65,9.93,9.93,0,0,0,3-2.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    className: "cls-10",
    d: "M1016.18,75.78s-.16,4.9,4.73,5.06c0,0-2.62,5.12-5.07,4.88"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEmployeeProfileBanner);
export default __webpack_public_path__ + "static/media/create-employee-profile-banner.57f9c0e3e258a4f82581ee1b43a508c3.svg";
export { ForwardRef as ReactComponent };